export const GENERIC_FAIL_MESSAGE = 'An unexpected error has occurred.  We were unable to process this request. '

export const NEED_ADMIN_MESSAGE = 'Please have an admin at your organization accept the permission conssent for this application.'